/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrentUserDto } from '../models/CurrentUserDto';
import type { CustomerTrackingDto } from '../models/CustomerTrackingDto';
import type { NotificationSettingsDto } from '../models/NotificationSettingsDto';
import type { UserVerificationLevelDto } from '../models/UserVerificationLevelDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CurrentUserDto Success
     * @throws ApiError
     */
    public getApiAccountsCurrentuser(): CancelablePromise<CurrentUserDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accounts/currentuser',
        });
    }
    /**
     * @returns any Success
     * @throws ApiError
     */
    public putApiAccountsAcceptPromotions(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/accounts/accept-promotions',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public putApiAccountsTwoFactorAuthEnabled(
        requestBody?: boolean,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/accounts/two-factor-auth-enabled',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns NotificationSettingsDto Success
     * @throws ApiError
     */
    public getApiAccountsNotificationSettings(): CancelablePromise<NotificationSettingsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accounts/notification-settings',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns NotificationSettingsDto Success
     * @throws ApiError
     */
    public putApiAccountsNotificationSettings(
        requestBody?: NotificationSettingsDto,
    ): CancelablePromise<NotificationSettingsDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/accounts/notification-settings',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiAccountsTracking(
        requestBody?: Array<CustomerTrackingDto>,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/accounts/tracking',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns UserVerificationLevelDto Success
     * @throws ApiError
     */
    public getApiAccountsVerificationLevel(): CancelablePromise<UserVerificationLevelDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accounts/verification-level',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
